import { useState, useEffect, useContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchUserProfile } from './fetchUserProfile';
import { GlobalContext } from './GlobalState';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';

export function MainAppBar() {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const { setProfileData, clearProfileData, activeProfile } =
    useContext(GlobalContext);

  const [loggedUser, setLoggedUser] = useState([]);
  const [loggedUserGroups, setLoggedUserGroups] = useState([]);
  const { route, signOut } = useAuthenticator((context) => [
    context.route,
    context.signOut,
  ]);
  const { user } = useAuthenticator((context) => [context.user]);
  const navigate = useNavigate();

  async function logOut() {
    await signOut();
    navigate('/login');
    clearProfileData();
  }

  useEffect(() => {
    async function getLoggedUser() {
      if (route === 'authenticated') {
        const response = await Auth.currentUserInfo();
        setLoggedUser(response.username);
        const userGroups =
          user.signInUserSession.accessToken.payload['cognito:groups']; //array of group names
        setLoggedUserGroups(userGroups);
        // set global user profile
        const profile = await fetchUserProfile(user);
        const profileWithGroups = { ...profile, memberOf: userGroups };
        setProfileData(profileWithGroups);
      }
    }
    getLoggedUser();
  }, [user?.username, route]);

  //   useEffect(() => {
  //     async function profileFetch() {
  //         if (route === 'authenticated') {
  //                     // set global user profile
  //         const profile = await fetchUserProfile(user);
  //         const profileWithGroups = { ...profile, memberOf: userGroups };
  //         // setProfileData(profileWithGroups);
  //             setProfileData((s) => profileWithGroups)
  //         }
  //     }
  //   },[route, user])

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="a"
              //   href="#app-bar-with-responsive-menu"
              // font-family= 'Egg Roll', sans-serif;
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              ESi Motorsports
              {/* {activeProfile?.sponsor} */}
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                <MenuItem onClick={() => navigate('/')}>
                  <Typography textAlign="center">Welcome</Typography>
                </MenuItem>
                {loggedUserGroups?.includes('Admin') && (
                  <MenuItem onClick={() => navigate('/watch')}>
                    Watch Now
                  </MenuItem>
                )}
                <MenuItem onClick={() => navigate('/viewer')}>
                  Review Sessions
                </MenuItem>
                <MenuItem onClick={() => navigate('/team-vitals')}>
                  Team Vitals
                </MenuItem>
                <MenuItem onClick={() => navigate('/racer-profiles')}>
                  Racer Profiles
                </MenuItem>
                {loggedUserGroups?.includes('Admin') && (
                  <MenuItem
                    onClick={() => navigate(`/telemetry-stream/${loggedUser}`)}
                  >
                    Telemetry Stream
                  </MenuItem>
                )}
                {loggedUserGroups?.includes('Admin') && (
                  <MenuItem onClick={() => navigate('/video-admin')}>
                    Video Admin
                  </MenuItem>
                )}
              </Menu>
            </Box>
            <Typography
              variant="h5"
              noWrap
              component="a"
              //   href="#app-bar-with-responsive-menu"
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              ESi
              {/* {activeProfile?.sponsor} */}
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              <Button
                onClick={() => navigate('/')}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                Welcome
              </Button>
              {loggedUserGroups?.includes('Admin') && (
                <Button
                  onClick={() => navigate('/watch')}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  Watch Now
                </Button>
              )}
              <Button
                onClick={() => navigate('/viewer')}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                Review Sessions
              </Button>
              <Button
                onClick={() => navigate('/racer-profiles')}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                Racer Profiles
              </Button>
              <Button
                onClick={() => navigate('/team-vitals')}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                Team Vitals
              </Button>
              {loggedUserGroups?.includes('Admin') && (
                <Button
                  onClick={() => navigate(`/telemetry-stream/${loggedUser}`)}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  Telemetry Stream
                </Button>
              )}
              {loggedUserGroups?.includes('Admin') && (
                <Button
                  onClick={() => navigate('/video-admin')}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  Video Admin
                </Button>
              )}
            </Box>

            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar
                    alt={activeProfile?.name}
                    src={activeProfile?.profileImage}
                  />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem>
                  {route !== 'authenticated' ? (
                    <Button onClick={() => navigate('/login')}>Login</Button>
                  ) : (
                    <>
                      <Typography>
                        <strong>{activeProfile?.name}</strong> ({loggedUser})
                      </Typography>
                    </>
                  )}
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => navigate('/manage-profile')}>
                  Edit Profile
                </MenuItem>
                {loggedUserGroups?.includes('Admin') && (
                  <MenuItem onClick={() => navigate('/video-admin')}>
                    Video Admin
                  </MenuItem>
                )}
                <MenuItem onClick={logOut}>Logout</MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Outlet />
    </>
  );
}
